import React, { FC } from 'react';
import { HorizontalDivider } from '@app/react/uikit/HorizontalDivider';

interface ZoomButtonProps {
    zoomIn: () => void;
    zoomOut: () => void;
}

export const ZoomButton: FC<ZoomButtonProps> = (props) => {
    const { zoomIn, zoomOut } = props;

    return (
        <div className="zoom-button">
            <button type="button" className="btn-zoom-style" onClick={zoomIn}>
                &#43;
            </button>
            <HorizontalDivider className="mt-side-10" />
            <button type="button" className="btn-zoom-style" onClick={zoomOut}>
                &#8722;
            </button>
        </div>
    );
};
